import React from 'react';
import GatewayClinicHoursSkeleton from './GatewayClinicHoursSkeleton';

function GatewayClinicHours({hours, isLoading}) {
    if (isLoading) {
        return <GatewayClinicHoursSkeleton/>;
    }

    if (!hours || hours.length === 0) {
        return <p className="text-muted small mb-0">No clinic hours available.</p>;
    }

    return (
        <ul className="list-unstyled gateway-clinic-hours-list mb-0">
            {hours.map((item, index) => (
                <li key={index} className="gateway-clinic-hours-item">
                    <div className="gateway-clinic-hours-row">
                        <span className="gateway-clinic-hours-day">{item.day}</span>
                        <span className="gateway-clinic-hours-time">
                            {item.status ? `${item.start} - ${item.end}` : 'Closed'}
                        </span>
                    </div>
                    {item.note && (
                        <p className="gateway-clinic-hours-note mb-0">
                            <span className="gateway-clinic-hours-note-label">Notes:</span>{' '}
                            {item.note}
                        </p>
                    )}
                </li>
            ))}
        </ul>
    );
}

export default GatewayClinicHours;
